import React from 'react';
import { Sparkles } from 'lucide-react';

interface LogoProps {
  onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = ({ onClick }) => {
  return (
    <div
      className="brand-logo"
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      onClick={onClick}
    >
      <div className="brand-icon-wrapper">
        <Sparkles size={22} color="#ffffff" />
      </div>
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span className="brand-title">SoulSync</span>
          <span className="brand-tag">STUDIO</span>
        </div>
        <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', margin: 0 }}>
          Collaborative Scene Dubbing
        </p>
      </div>
    </div>
  );
};
